import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import i18next, { LOCALE_STORAGE_KEY, type Locale } from '@/lib/i18n';

interface LocaleState {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

function applyLocale(locale: Locale): void {
  document.documentElement.lang = locale;
  void i18next.changeLanguage(locale);
}

export const useLocaleStore = create<LocaleState>()(
  persist(
    (set) => ({
      locale: i18next.language as Locale,
      setLocale: (locale) => {
        applyLocale(locale);
        set({ locale });
      },
    }),
    {
      name: LOCALE_STORAGE_KEY,
      onRehydrateStorage: () => (state) => {
        if (state) applyLocale(state.locale);
      },
    },
  ),
);

if (typeof document !== 'undefined') {
  // Apply immediately on first load (before any component mounts) to avoid a flash.
  applyLocale(useLocaleStore.getState().locale);
}
